export default __webpack_public_path__ + "static/media/prestige-custom-awards.1ddea8dc.png";